"use client";

// Contexto de idioma — exposto pra Client Components que precisam de
// `t(key)`, `lang` ou `setLang` em qualquer profundidade da árvore.
// O Provider real é criado no SiteShell, que recebe `locale` do layout
// `app/[locale]/layout.jsx` (extraído de params) e injeta o resultado
// aqui dentro.
//
// `setLang` aqui faz `router.push` trocando o segmento de locale na URL —
// não persiste em localStorage, a URL é a única fonte de verdade.

import { createContext, useContext } from "react";

const LangContext = createContext({
  lang: "pt",
  setLang: () => {},
  t: (key) => key,
});

export const LangProvider = LangContext.Provider;

export function useLangContext() {
  return useContext(LangContext);
}
